import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import deviceList from '@blade-sxp/task-management/components/deviceDarwer/device-list.vue';
import DarwerPlot from '@blade-sxp/task-management/components/deviceDarwer/darwer-plot.vue';
import NoDeviceId from '@blade-sxp/task-management/components/deviceDarwer/no-device-id.vue';
import { plotMap } from './plotConfig';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { getQueryDeviceDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { isEmpty, debounce, cloneDeep } from 'lodash';
import DeviceCascader from '@blade-sxp/task-management/components/device-cascader.vue';
// import { namespace } from 'vuex-class';
const Service = { getQueryDeviceDetail };
// const Data = namespace('senseXplorer/DeviceIdData');
let DeviceDarwer = class DeviceDarwer extends Vue {
    taskType;
    value;
    disabled;
    // @Data.State((state) => state.deviceIdRequestParams) deviceIdRequestParams: any;
    deviceIdList = [];
    drawingProcess = {
        roi: false,
        map: false,
        direction: false,
        bodyFrame: false,
    };
    styleProp = {
        width: 644,
        height: 378,
    };
    deviceStyle = '';
    casecaderStatus = true;
    deviceIdDataMap = new Map();
    deviceIdRest = null;
    treeFinishStatus = false;
    isDeviceIdDataModule = false;
    deviceStatus = false;
    multiple = true;
    searchCondition = {
        excludeUngroupDevice: true,
        filterVpsSupport: true,
    };
    // @Watch('deviceIdRequestParams', { immediate: true, deep: true })
    // onDataChange(val: any) {
    //   const type = this.$route.query.type;
    //   if (type !== 'add') {
    //     if (!isEmpty(val)) {
    //       let deviceData: string[] = [];
    //       val.forEach((item: any) => {
    //         deviceData.push(item.deviceId);
    //       });
    //       this.deviceIdList = deviceData;
    //       this.isDeviceIdDataModule = true;
    //     }
    //   }
    // }
    onChangeDeviceIdList(val) {
        const isShowRoi = plotMap.get(this.taskType);
        const len = isShowRoi?.timeline?.length === 0;
        const notNecessarily = isShowRoi?.notNecessarily;
        // 如果不用画框，只要选择了设备就为true
        if (len || notNecessarily) {
            if (!isEmpty(val)) {
                this.$emit('input', true);
            }
            else {
                this.$emit('input', false);
            }
        }
        if (val && val.length === 0) {
            this.$emit('selectedDevices', []);
        }
    }
    // 需要画框
    onChangeComplete(val) {
        const isShowRoi = plotMap.get(this.taskType);
        const notNecessarily = isShowRoi?.notNecessarily;
        const len = isShowRoi?.timeline?.length === 0;
        if (!len && !isEmpty(this.deviceIdList)) {
            if (val || notNecessarily) {
                this.$emit('input', true);
            }
            else {
                this.$emit('input', false);
            }
        }
    }
    // 判断任务类型
    onChangeTaskType(val) {
        if (val) {
            if (val === 'CROWD_CROSS_LINE_STATISTIC' || val === 'CROWD_STATISTIC') {
                this.multiple = false;
            }
            else {
                this.multiple = true;
            }
        }
        DeviceIdDataModule.setTaskType(val);
        if (val && plotMap) {
            const value = plotMap.get(val);
            if (value) {
                this.drawingProcess = plotMap.get(val).drawingProcess;
                const status = Object.values(this.drawingProcess).some((item) => item === true);
                this.getDeviceStyle(status);
            }
        }
    }
    init(val) {
        const { type } = val.query;
        if (type !== 'add') {
            const echoData = DeviceIdDataModule?.deviceIdRequestParams;
            if (!isEmpty(echoData)) {
                let deviceData = [];
                echoData.forEach((item) => {
                    deviceData.push(item.deviceId);
                });
                this.deviceIdList = deviceData;
                this.isDeviceIdDataModule = true;
            }
            else {
                this.deviceIdDataMap.clear();
                DeviceIdDataModule.setDeviceIdRequestParams(this.deviceIdDataMap);
            }
        }
    }
    get isSelectDevice() {
        const status = this.deviceIdList?.length > 0;
        return status;
    }
    get justWatchVideos() {
        const status = Object.values(this.drawingProcess).some((item) => item === true);
        if (status) {
            this.styleProp = {
                width: 644,
                height: 378,
            };
        }
        else {
            this.styleProp = {
                width: 680,
                height: 462,
            };
        }
        return status;
    }
    get isDarwerComplete() {
        return DeviceIdDataModule.complete;
    }
    created() {
        this.deviceIdRest = debounce(() => {
            if (!this.multiple) {
                DeviceIdDataModule?.deviceIdRequestParams?.clear();
                DeviceIdDataModule?.markMapData?.clear();
                DeviceIdDataModule?.updataIsMapData(false);
            }
            this.deviceIdRestMap(this.deviceIdList);
        }, 1000);
    }
    beforeDestroy() {
        DeviceIdDataModule?.deviceIdRequestParams?.clear();
        DeviceIdDataModule?.updataDeviceId('');
        DeviceIdDataModule?.updataCurrentRtspUrl('');
        DeviceIdDataModule?.clearMonitoringIndex();
        DeviceIdDataModule?.updataComplete(false);
    }
    getDeviceStyle(status) {
        let deviceStyle = '';
        if (status) {
            deviceStyle = `height:51rem;min-width:112rem;min-height:51rem;width:112rem;`;
        }
        else {
            deviceStyle = `height:51rem;min-width:90.2rem;min-height:51rem;width:90.2rem;`;
        }
        this.deviceStyle = deviceStyle;
    }
    deviceIdRestMap(val) {
        this.deviceStatus = true;
        const data = plotMap.get(this.taskType).timeline;
        if (isEmpty(data)) {
            if (!isEmpty(val)) {
                this.setDeviceIdMap(val);
                this.regionList(val);
            }
            else {
                this.deviceIdDataMap.clear();
                this.isDeviceIdDataModule = false;
                DeviceIdDataModule.setDeviceIdRequestParams(this.deviceIdDataMap);
            }
            this.deviceStatus = false;
        }
        else {
            this.handleData(val);
            DeviceIdDataModule.updataDeviceId(val[0]);
        }
    }
    handleData(val) {
        // let dataMap = new Map();
        this.isDeviceIdDataModule = false;
        const type = plotMap.get(this.taskType).timeline;
        let data = {
            id: '',
            isComplete: false,
            zoneId: '',
            deviceId: '',
            titleList: type,
        };
        if (!isEmpty(val)) {
            // 新增时要判断是否已经存在，如果存在就不新增了
            val.forEach((item) => {
                const isAlreadyExist = DeviceIdDataModule?.deviceIdRequestParams?.has(item) || false;
                // 没有
                if (!isAlreadyExist) {
                    let listMap = cloneDeep(data);
                    listMap.id = item;
                    listMap.deviceId = item;
                    // dataMap.set(item, listMap);
                    DeviceIdDataModule.deviceIdRequestParams.set(item, listMap);
                    this.isDeviceIdDataModule = true;
                }
                else {
                    DeviceIdDataModule.deviceIdRequestParams.forEach((item) => {
                        if (!val.includes(item.id)) {
                            DeviceIdDataModule?.deviceIdRequestParams?.delete(item.id);
                        }
                    });
                    this.isDeviceIdDataModule = true;
                }
            });
            this.multipleZoneId(val);
        }
        else {
            // 清空map 数据
            this.isDeviceIdDataModule = false;
            this.deviceStatus = false;
            DeviceIdDataModule?.deviceIdRequestParams?.clear();
        }
    }
    multipleZoneId(val) {
        try {
            Service.getQueryDeviceDetail(val)
                .then((res) => {
                if (!isEmpty(res)) {
                    res.forEach((item) => {
                        const data = DeviceIdDataModule.deviceIdRequestParams.get(item.id);
                        data.zoneId = item.zoneId;
                        DeviceIdDataModule.deviceIdRequestParams.set(item.id, data);
                    });
                }
            })
                .finally(() => {
                this.deviceStatus = false;
            });
        }
        catch (error) {
            throw error;
        }
    }
    setDeviceIdMap(val) {
        let dataMap = new Map();
        val.forEach((item) => {
            dataMap.set(item, { zoneId: null, deviceId: item });
        });
        this.deviceIdDataMap = dataMap;
    }
    regionList(deviceIdList) {
        try {
            Service.getQueryDeviceDetail(deviceIdList).then((res) => {
                if (res && !isEmpty(res)) {
                    res.forEach((item) => {
                        this.deviceIdDataMap.set(item.id, { zoneId: item.zoneId, deviceId: item.id });
                    });
                }
                DeviceIdDataModule.setDeviceIdRequestParams(this.deviceIdDataMap);
                this.isDeviceIdDataModule = true;
            });
        }
        catch (error) {
            throw error;
        }
    }
    deleteDeviceId(id) {
        if (id && this.deviceIdList) {
            // 删除map数据
            DeviceIdDataModule?.deviceIdRequestParams?.delete(id);
            const index = this.deviceIdList.indexOf(id);
            if (index > -1) {
                const data = [...this.deviceIdList];
                data.splice(index, 1);
                this.deviceIdList = data;
            }
        }
    }
    dataFinishStatus(val) {
        this.treeFinishStatus = val;
    }
    removeValue(val) {
        DeviceIdDataModule?.deviceIdRequestParams?.delete(val);
        DeviceIdDataModule?.markMapData?.clear();
        DeviceIdDataModule?.updataIsMapData(false);
    }
    selectedDevices(devices) {
        this.$emit('selectedDevices', [...devices]);
    }
};
__decorate([
    Prop({ type: String, default: '' })
], DeviceDarwer.prototype, "taskType", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceDarwer.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceDarwer.prototype, "disabled", void 0);
__decorate([
    Watch('deviceIdList', { immediate: true, deep: true })
], DeviceDarwer.prototype, "onChangeDeviceIdList", null);
__decorate([
    Watch('isDarwerComplete', { immediate: true })
], DeviceDarwer.prototype, "onChangeComplete", null);
__decorate([
    Watch('taskType', { immediate: true })
], DeviceDarwer.prototype, "onChangeTaskType", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], DeviceDarwer.prototype, "init", null);
DeviceDarwer = __decorate([
    Component({
        name: 'DeviceDarwer',
        components: {
            'st-device-list': deviceList,
            'st-darwer-plot': DarwerPlot,
            'st-no-device-id': NoDeviceId,
            'st-device-cascader': DeviceCascader,
        },
        i18n: {
            messages: {
                en: {
                    device: 'Device',
                    tip: 'Tips',
                    moreTip: 'A maximum of 100 devices can be selected simultaneously.',
                    confirm: 'Confirm',
                },
                zh: {
                    device: '设备',
                    tip: '提示',
                    moreTip: '最多可同时选择100台设备。',
                    confirm: '确定',
                },
            },
        },
    })
], DeviceDarwer);
export default DeviceDarwer;
